<template>
    <b-card>
      <h4 slot="header">Surface Structure</h4>
      <b-form>
        <rx-check-box-with-text
          v-model="hasParkingLanes"
          :options="yesNoOptions"
          v-bind:text="hasParkingLanesDescription"
          v-on:update:text="hasParkingLanesDescription = $event"
          title-text="Parking Lanes"
          description="Indicate the existing presence of parking lane(s) in the direction of travel. Parking lanes, shoulders, and bicycle lanes may experience different loading traffic conditions than the lanes and consequently may feature a different pavement design."
          id="hasParkingLanes"
          :validation="$v.hasParkingLanes"
          ></rx-check-box-with-text>

        <rx-check-box-with-text
            v-model="hasShoulder"
            v-bind:text="hasShoulderDescription"
            v-on:update:text="hasShoulderDescription = $event"
            :options="yesNoOptions"
            title-text="Has Shoulder"
            description="Indicate the existing presence of shoulder(s) in the direction of travel. Parking lanes, shoulders, and bicycle lanes may experience different loading traffic conditions than the lanes and consequently may feature a different pavement design."
            id="hasShoulder"
            :validation="$v.hasShoulder"
        ></rx-check-box-with-text>

        <rx-check-box-with-text
          v-model="hasBikeLane"
          v-bind:text="hasBikeLaneDescription"
          v-on:update:text="hasBikeLaneDescription = $event"
          :options="yesNoOptions"
          title-text="Has Bike Lane"
          description="Indicate the existing presence of bike lane(s) in the direction of travel. Parking lanes, shoulders, and bicycle lanes may experience different loading traffic conditions than the lanes and consequently may feature a different pavement design."
          id="hasBikeLane"
          :validation="$v.hasBikeLane"
        ></rx-check-box-with-text>

        <rx-check-box-with-text
          v-model="hasCurb"
          v-bind:text="hasCurbDescription"
          v-on:update:text="hasCurbDescription = $event"
          :options="yesNoOptions"
          title-text="Has Curb"
          description="Indicate the existing presence of a curb that the rehabilitated pavement must match. If present, RxPave will provide a warning in the final results as a matching curb may affect required construction activities. "
          id="hasCurb"
          :validation="$v.hasCurb"
        ></rx-check-box-with-text>

        <rx-check-box-with-text
          v-model="hasOtherSurface"
          v-bind:text="hasOtherSurfaceDescription"
          v-on:update:text="hasOtherSurfaceDescription = $event"
          :options="yesNoOptions"
          title-text="Other Surface Features"
          description="This is an optional field for you to describe the presence of any other surface features, particularly ones that may result in different loading conditions, feature different pavement designs, or add complexity to construction. You may also add notes that further detail any of the above responses. "
          id="hasOtherSurface"
          :validation="$v.hasOtherSurface"
        ></rx-check-box-with-text>
      </b-form>
    </b-card>
</template>

<script>
  import { mapFields } from "vuex-map-fields";

  import { mapMutations } from 'vuex'
  // const { mapMutations } = createNamespacedHelpers('rx');


  import { validationMixin } from 'vuelidate';
  import { required, maxLength } from 'vuelidate/lib/validators'
  import {isValidSection2c} from "../../../js/validation/projectValidation";

  import RxTextEntryBox from './inputComponents/RxTextEntryBox.vue'
  import RxDropdown from './inputComponents/RxDropdown.vue'
  import RxNumberInput from './inputComponents/RxNumberInput.vue'
  import RxRadio from './inputComponents/RxRadio.vue'
  import RxCheckBoxWithText from "./inputComponents/RxCheckboxWithText";

  export default {
    name: "Section2C",
    components: {
      RxCheckBoxWithText,
      RxTextEntryBox,
      RxDropdown,
      RxNumberInput,
      RxRadio
    },
    props: [
      '$v'
    ],
    data() {
      return {
        yesNoOptions: [
          {text: 'Unsure', value: -1},
          {text: 'No', value: 0},
          {text: 'Yes', value: 1},
        ]
      };
    },
    computed: {
      ...mapFields('rx',[
        "currentProject",
        "currentProject.hasParkingLanes",
        "currentProject.hasParkingLanesDescription",
        "currentProject.hasShoulder",
        "currentProject.hasShoulderDescription",
        "currentProject.hasBikeLane",
        "currentProject.hasBikeLaneDescription",
        "currentProject.hasCurb",
        "currentProject.hasCurbDescription",
        "currentProject.hasOtherSurface",
        "currentProject.hasOtherSurfaceDescription",
      ])
    },
    validations: {
      hasParkingLanesDescription: {
        maxLength: maxLength(200)
      },
      hasShoulderDescription:{
        maxLength: maxLength(200)
      },
      hasBikeLaneDescription:{
        maxLength: maxLength(200)
      },
      hasCurbDescription:{
        maxLength: maxLength(200)
      },
      hasOtherSurfaceDescription:{
        maxLength: maxLength(200)
      }
    },
    beforeMount: function(){
      // this.setCardStyle();
    },
    updated: function () {
      console.log("Section 2B field validators match store validation:",
        isValidSection2c(this.currentProject) === !this.$v.$invalid);
      this.setValidSection({
        section: '2c',
        value: !this.$v.$invalid
      });
      // this.setCardStyle();
    },
    methods: {
      ...mapMutations('rx',[
        'validateProjectState',
        'setValidSection'
      ]),
    },
  }
</script>

<style scoped>

</style>